import React from 'react';
import { CaseStatus } from '../../types';

/**
 * Filter value type - either a specific status or 'all'
 */
export type StatusFilter = CaseStatus | 'all';

/**
 * Props for the CaseFilter component
 */
export interface CaseFilterProps {
  value: StatusFilter;
  onChange: (status: StatusFilter) => void;
}

/**
 * Filter options configuration
 */
const FILTER_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'closed', label: 'Closed' },
  { value: 'on-hold', label: 'On-Hold' },
];

/**
 * CaseFilter component - renders filter buttons for case status filtering.
 * 
 * Displays buttons for: All, Active, Closed, On-Hold
 * The currently selected filter is visually highlighted.
 * 
 * Requirements: 3.1
 */
export const CaseFilter: React.FC<CaseFilterProps> = ({ value, onChange }) => {
  return (
    <div
      data-testid="case-filter"
      style={{
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
      }}
    >
      {FILTER_OPTIONS.map((option) => {
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            data-testid={`case-filter-${option.value}`}
            onClick={() => onChange(option.value)}
            style={{
              padding: '8px 16px',
              borderRadius: '20px',
              border: isSelected ? 'none' : '1px solid #ddd',
              backgroundColor: isSelected ? '#1976d2' : 'white',
              color: isSelected ? 'white' : '#333',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: isSelected ? 600 : 400,
              transition: 'all 0.2s',
            }}
            onMouseOver={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = '#f5f5f5';
              }
            }}
            onMouseOut={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = 'white';
              }
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
